import { environment } from '@bvl-admin/environments/environment';

export class AuthEndpoint {
  public static login = `${environment.LOAD_BALANCER}/api/authenticate`;
}
